import React, { useEffect, useState } from 'react';
import styles from './BannerStrip.module.css';
import { BannerApi } from '../../../services/bannerAPI';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000'; 

const BannerStrip = () => {
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const res = await BannerApi.get_banners();
        const data = res?.data || res || []; 
        if (mounted) setBanners(data);
      } catch (e) {
        console.error('Erro ao carregar banners:', e);
      }
    })();
    return () => { mounted = false };
  }, []);

  if (!banners.length) return null;

  // Filtramos apenas banners que possuem imagem para evitar espaços vazios no slider
  const validBanners = banners.filter(b => b.image);
  const displayBanners = [...validBanners, ...validBanners];

  return (
    <section className={styles.container}>
      <div className={styles.track}>
        {displayBanners.map((b, index) => (
          <div key={`${b.id}-${index}`} className={styles.item}>
            <a href={b.product_id ? `/product/${b.product_id}` : '#'} className={styles.link}>
              <div className={styles.imageWrapper}>
                <img 
                  src={b.image ? `${API_BASE_URL}/static/uploads/banners/${b.image}` : 'https://via.placeholder.com/1920x600?text=Banner'} 
                  alt="Banner Promocional" 
                  className={styles.image}
                  onError={(e) => { e.target.src = 'https://via.placeholder.com/1920x600?text=Erro+Imagem'; }}
                />
              </div>
            </a>
          </div>
        ))}
      </div>
    </section>
  );
};

export default BannerStrip;